import React from 'react';
import styles from '../AiDialog.module.css';

export function ContextDescription({
  introText,
  trailingText,
  hasCategory,
  hasCuisine,
  productCategory,
  cuisineType,
}) {
  return (
    <p className={styles.contextText}>
      {introText}
      {hasCategory && `, category "${productCategory}"`}
      {hasCuisine && `, and cuisine "${cuisineType}"`} {trailingText}
    </p>
  );
}
